import type { FC } from 'react';

import { useLocation, Navigate, Outlet, useMatch } from 'react-router-dom';

import { useAuthContext } from 'components/context/AuthContext/AuthContext';
import LayoutUnauthorized from 'components/root/LayoutUnauthorized/LayoutUnauthorized';
import LoaderOverlay from 'components/UI/molecules/LoaderOverlay/LoaderOverlay';
import PATHS from 'constants/router/PATHS';
import { useRememberedPathFromUrl } from 'hooks/_rememberedPath/useRememberedPathFromUrl/useRememberedPathFromUrl';

const AuthPage: FC = () => {
  const { userInfo, logout } = useAuthContext();
  const location = useLocation();
  const isPasswordResetForm = !!useMatch(PATHS.AUTH_RESET_PASSWORD_FORM);
  const { rememberedPath } = useRememberedPathFromUrl();

  if (userInfo.isAuthorized === null) return <LoaderOverlay />;

  if (userInfo.isAuthorized) {
    if (isPasswordResetForm) {
      logout();
      return (
        <LayoutUnauthorized>
          <Outlet />
        </LayoutUnauthorized>
      );
    }

    return <Navigate replace state={{ from: location }} to={rememberedPath || PATHS.ROOT} />;
  }

  return (
    <LayoutUnauthorized>
      <Outlet />
    </LayoutUnauthorized>
  );
};

export default AuthPage;
